import React from 'react';

const HomeIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.6081 8.1556L9.94594 0.4934C9.42349 -0.02905 8.57649 -0.02905 8.05404 0.4934L0.391842 8.1556C0.00924158 8.5382 -0.105158 9.1136 0.101842 9.6135C0.308942 10.1134 0.796742 10.4393 1.33779 10.4393H2.37589V16.168C2.37589 17.1236 3.15054 17.8982 4.10604 17.8982H13.8939C14.8494 17.8982 15.6241 17.1236 15.6241 16.168V10.4393H16.6622C17.2032 10.4393 17.6911 10.1133 17.8981 9.6135C18.1051 9.1136 17.9907 8.5382 17.6081 8.1556ZM11.0215 15.3891H6.97844V13.11C6.97844 11.9935 7.88354 11.0884 8.99999 11.0884C10.1164 11.0884 11.0215 11.9934 11.0215 13.11V15.3891Z" fill="#C0C0C0"/>
    </svg>

  );
};

export default HomeIcon;
